"use strict";
// Weather utilities - EXAKT samma som frontend weatherUtils.ts
Object.defineProperty(exports, "__esModule", { value: true });
exports.logistic01 = exports.gaussian = exports.clamp01 = void 0;
exports.geomMeanWeighted = geomMeanWeighted;
exports.calculateMoonPhase = calculateMoonPhase;
exports.getMoonPhaseLabel = getMoonPhaseLabel;
exports.getWindDirection = getWindDirection;
// Math utilities
const clamp01 = (x) => Math.max(0, Math.min(1, x));
exports.clamp01 = clamp01;
const gaussian = (x, mu, sigma) => (0, exports.clamp01)(Math.exp(-0.5 * Math.pow((x - mu) / (sigma || 1), 2)));
exports.gaussian = gaussian;
const logistic01 = (x, k = 1, x0 = 0) => 1 / (1 + Math.exp(-k * (x - x0)));
exports.logistic01 = logistic01;
function geomMeanWeighted(pairs) {
    const sumW = pairs.reduce((a, p) => a + p.w, 0);
    if (sumW === 0)
        return 0;
    const logSum = pairs.reduce((a, p) => a + (p.s <= 0 ? -50 : Math.log(p.s)) * (p.w / sumW), 0);
    return Math.exp(logSum);
}
// Moon phase utilities
function calculateMoonPhase(date) {
    const knownNewMoon = new Date('2024-01-11T11:57:00.000Z');
    const lunarCycle = 29.530588853;
    const daysDiff = (date.getTime() - knownNewMoon.getTime()) / (1000 * 60 * 60 * 24);
    let phase = (daysDiff / lunarCycle) % 1;
    if (phase < 0)
        phase += 1;
    return phase;
}
function getMoonPhaseLabel(phase) {
    if (phase >= 0 && phase < 0.03)
        return 'New Moon';
    if (phase >= 0.03 && phase < 0.22)
        return 'Waxing Crescent';
    if (phase >= 0.22 && phase < 0.28)
        return 'First Quarter';
    if (phase >= 0.28 && phase < 0.47)
        return 'Waxing Gibbous';
    if (phase >= 0.47 && phase < 0.53)
        return 'Full Moon';
    if (phase >= 0.53 && phase < 0.72)
        return 'Waning Gibbous';
    if (phase >= 0.72 && phase < 0.78)
        return 'Last Quarter';
    if (phase >= 0.78 && phase < 0.97)
        return 'Waning Crescent';
    if (phase >= 0.97 && phase <= 1.0)
        return 'New Moon';
    return 'New Moon';
}
// Wind utilities
function getWindDirection(deg) {
    const dirs = ['N', 'NE', 'E', 'SE', 'S', 'SW', 'W', 'NW'];
    const index = Math.round(deg / 45) % 8;
    return dirs[index];
}
